<template>
  <div class="send-generic-hsm">
    <page-header title="Enviar HSM genérico">
      <template #description>
        Disparo manual de mensagens HSM (templates pré-aprovados de
        WhatsApp) em lote. Faça upload de um CSV com a lista de
        destinatários (student_id ou phone_number) e os parâmetros do
        template, escolha o HSM e dispare.
      </template>
    </page-header>

    <z-card class="send-generic-hsm__usage">
      <strong>Observações:</strong>
      <ul>
        <li>
          A primeira coluna da tabela precisa ser o <b>ID do aluno</b> que será
          enviada a mensagem, <b>ela precisa se chamar student_id</b>
          ou o número do celular nomeada como <b>phone_number</b>.
        </li>
        <li>
          Todas as outras colunas serão consideradas parâmetros da mensagem e
          <b>precisam ser preenchidas na ordem</b>
        </li>
      </ul>
      <strong>Exemplo:</strong>
      <ul>
        <li>
          Se for enviar sua mensagem com base no ID do aluno e seu conteúdo for "Olá {1}, seu curso é {2}",
          sua planilha precisará ter as colunas nessa ordem: student_id, user_name, course_name,
          veja <a :href="sendHsmByStudentIdModel" target="_blank">exemplo</a>;
        </li>
        <br>

        <li>
          Se for enviar sua mensagem com base no número de telefone do aluno e seu conteúdo
          for "Olá {1}, seu curso é {2}",
          sua planilha precisará ter as colunas nessa ordem: phone_number, user_name, course_name;
          O telefone do usuário deve seguir o formato 55+DDD+número (5512999999999),
          veja <a :href="sendHsmByPhoneNumberModel" target="_blank">exemplo</a>;
        </li>
        <br>

        <li>
          <b>Atenção</b> ao fazer o download da planilha exemplo, atente-se em posteriormente
          <b>salvar a mesma no formato .csv</b>
        </li>
      </ul>
    </z-card>

    <div class="send-generic-hsm__inputs">
      <div class="send-generic-hsm__inputs-template">
        <label>Template:</label>
        <input
          class="form-input"
          type="text"
          placeholder="Digite o nome do template"
          v-model="templateName"
        >
      </div>

      <div class="send-generic-hsm__inputs-spreadsheet">
        <label>Planilha com Alunos (CSV):</label>
        <input
          id="spreadsheet"
          type="file"
          accept=".csv"
          @change="uploadSpreadsheet"
        >
      </div>
    </div>

    <button
      class="send-generic-hsm__button btn btn-primary btn-primary"
      type="button"
      :disabled="buttonDisabled"
      @click="sendHsm"
    >
      Enviar HSMs
    </button>
  </div>
</template>

<script>
import StudentsService from 'services/StudentsService';

const baseURL = 'https://docs.google.com/spreadsheets';
const sendHsmByStudentIdModel = `${baseURL}/d/1FVm2iq-PBs72S0RwxnMGc0KD8gSDi65Jco0g2_xr5Co/edit#gid=0`;
const sendHsmByPhoneNumberModel = `${baseURL}/d/1c4vNAX2zuQouT-d2w-fX9o-fVAUgkT8IB2NC40iOvBc/edit#gid=0`;

export default {
  data() {
    return {
      templateName: '',
      file: null,
      sendHsmByStudentIdModel,
      sendHsmByPhoneNumberModel,
    };
  },
  computed: {
    buttonDisabled() {
      return !this.templateName || !this.file;
    },
  },
  methods: {
    uploadSpreadsheet({ target }) {
      const { files } = target;
      const [file] = files;

      if (files && file) {
        this.file = file;
      }
    },
    sendHsm() {
      this.$loader.show();

      StudentsService.sendHsms(this.file, this.templateName)
        .then(() => this.$alert.notifySuccess('HSMs enviados com sucesso!'))
        .catch((error) => {
          const message = error.response?.data?.message || 'Tente novamente ou contate o Suporte!';

          this.$alert.notifyAlert(`Erro ao enviar HSMs: ${message}`);
        })
        .finally(() => this.$loader.hide());
    },
  },
};
</script>

<style lang="scss" scoped>
.send-generic-hsm {
  width: 115vh;
  margin-left: var(--space-medium);
}

.send-generic-hsm__usage {
  display: flex;
  flex-direction: column;
  gap: var(--space-small);
}

.send-generic-hsm__inputs {
  display: flex;
  gap: var(--space-medium);
  margin-top: var(--space-medium);
  justify-content: space-between;
}

.send-generic-hsm__inputs-template {
  display: flex;
  align-items: center;
  gap: var(--space-small);
  width: 45%;
}

.send-generic-hsm__inputs-spreadsheet {
  display: flex;
  align-items: center;
  gap: var(--space-small);
}

.send-generic-hsm__button {
  margin-top: var(--space-large);
  width: 15vh;
}

.form-input {
  margin: 0;
}

.label {
  margin-bottom: 0;
}
</style>
